import { Component, HostListener, OnInit } from '@angular/core';
import {ChartOptions, ChartType} from "chart.js";
import {Label, monkeyPatchChartJsLegend, monkeyPatchChartJsTooltip, SingleDataSet} from "ng2-charts";
import {ActivatedRoute, Router} from "@angular/router";
import {CourseService} from "../../shared/services/course.service";
import {Subscription} from "rxjs";
import {ErrorHandlerService} from "../../shared/services/error-handler.service";
import { AuthService } from 'src/app/shared/services/auth.service';
import { GlobalService } from 'src/app/shared/services/global.service';
import { QuizGeneratorService } from 'src/app/shared/services/quiz-generator.service';
import { AdminService } from 'src/app/shared/services/admin.service';
import { demo_variables } from 'src/app/models/demo_global';
import { StudyPlanService } from 'src/app/study-planner/services/study-plan.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.scss']
})
export class OverviewComponent implements OnInit {
  // This is overview screen i.e, Welcome screen of user dashboard
  totalCorrectPercentage: any = 50;
  totalUsedPercentage: any = 20;
  smallfinalarray = [{ID: 103333,
    post_name: "Free Trial",
    post_title: "Free Trial",
    value: 10.04,
    courseImage: "http://elhusseinyusmleprep.com/wp-content/uploads/2020/11/free.png"
  }
    ]
  // @ts-ignore
  subscriptions: Subscription[] = [];
  loader = true;
  multiplier = 100;
  totalcourses: any;
  completedcouses: any;
  enrolledcourses: any;
  courses: any;
  percentages: any;
  // Adding percentages and total courses api data in one variable
  finalCourseArray: any;
  // Making copy of it to save it for search function
  finalCourseArray2: any;

  // smallfinalarray: any;

  // smallfinalarray: any;
  contentLoader = true;
  demo = false;

  searchText = ''

  totalQues = 1;
  unusedQues = 1;
  usedQues = 3;
  courseId: any = [];

  // Study Planner Stats Properties
  studyPlannerLoader = false;
  studyPlannerData: any = null;
  upcomingTasks: any[] = [];
  overdueTasks: any[] = [];
  selectedTab = 'upcoming'; // 'upcoming' or 'overdue'
  studyPlannerStats = {
    completedTasks: 0,
    overdueTasks: 0,
    incompleteTasks: 0,
    completionPercentage: 0
  };
  
  // NavigateToTask functionality properties
  displayQuiz = false;
  selectedQbanks = [];
  courses_navigation: any = []
  selectedCourse_navigation = null;
  
  // Video modal properties
  showVideoModal = false;
  currentVideoUrl: any = null;
  
  // Doughnut chart data for study planner
  studyPlannerChartData: SingleDataSet = [];
  studyPlannerChartLabels: Label[] = ['Completed', 'Overdue', 'Incomplete', 'Remaining'];
  studyPlannerChartColors: Array<any> = [
    {
      backgroundColor: [
        'rgb(99, 188, 66)',    // Completed - green
        'rgb(240, 90, 91)',    // Overdue - red  
        'rgb(104, 155, 247)',  // Incomplete - blue
        'rgb(220, 220, 220)'   // Remaining - grey
      ]
    }
  ];
  studyPlannerChartOptions: any = {
    responsive: true,
    maintainAspectRatio: false,
    cutoutPercentage: 80,
    plugins: {
      legend: {
        display: false
      }
    },
    elements: {
      arc: {
        borderWidth: 3,
        borderColor: '#ffffff'
      }
    }
  };

  pointersColorClasses = ['eup-green-pointer','eup-red-pointer','eup-blue-pointer','eup-purple-pointer'];
  chartType: ChartType = 'pie';
  pieChartOptions: ChartOptions = {
    responsive: true,
  };
  chartColors: Array<any> = [
    {
      backgroundColor: [
        '#61ce87',
        '#e14f6a',
        '#389cf2',
        '#7583f0'
      ]
    }
  ];
  pieChartLabels1: Label[] = [['Total Questions'], ['Used  Questions'], ['Unused Questions']];
  pieChartLabels: Label[] = [['Correct to Correct'], ['Correct to Incorrect'], ['Incorrect to Correct'], ['Incorrect to Incorrect']];
  pieChartData1: SingleDataSet = [12, 2, 10];
  pieChartData: SingleDataSet = [20, 16, 36, 40];
  pieChartType: ChartType = 'pie';
  pieChartLegend = false;
  pieChartPlugins = [];
  cardLabels = [
    {label: 'Total Correct', value: 2, bgClass: 'eup-green-card'},
    {label: 'Total Incorrect', value: 2, bgClass: 'eup-red-card'},
    {label: 'Total Omitted', value: 5, bgClass: 'eup-blue-card'},
    // {label: 'Incorrect to Incorrect', value: 20, bgClass: 'eup-purple-card'},
  ];

  cardLabels1 = [
    {label: 'Total Questions', value: 12, bgClass: 'eup-green-card'},
    {label: 'Used Questions', value: 2, bgClass: 'eup-red-card'},
    {label: 'Unused Questions', value: 10, bgClass: 'eup-blue-card'}
  ];


  // Week navigation properties
  currentWeekStart: Date = new Date();
  currentWeekEnd: Date = new Date();
  currentWeekLabel: string = '';
  showWeekNavigation: boolean = false;
  hasNoDataForCurrentWeek: boolean = false;



  innerWidth: any;
  @HostListener('window:resize', ['$event'])
onResize(event) {
  this.innerWidth = window.innerWidth;
  if(this.innerWidth < 750){
    document.getElementById('eup-navbar-heading').innerText=''
  }
}

  constructor(private adminService: AdminService,private quizgeneratorService: QuizGeneratorService ,private globalService: GlobalService,private authService: AuthService, private route:ActivatedRoute, private router:Router, private courseService: CourseService, private errorHandler: ErrorHandlerService, private studyPlanService: StudyPlanService, private sanitizer: DomSanitizer ) {

  }

  async ngOnInit(){

    this.initializeCurrentWeek();
    if(!localStorage.getItem("token")){
      this.router.navigate(['/']);
    }
    else{
    }
    if(localStorage.getItem('Id') == '-1'){
      this.demo = true;
    }
    if(this.demo){
      this.getDemoVariables()
    }
    else{
      let index = 0;
    if (localStorage.getItem('subscriptions')) {
      this.subscribedCourses = JSON.parse(localStorage.getItem('subscriptions'))
      this.courseId = this.subscribedCourses.map((item: any) => item.courseID)
      
      // Initialize navigation properties
      this.courses_navigation = JSON.parse(localStorage.getItem('subscriptions')) || []
      if (this.courses_navigation.length > 0) {
        if (localStorage.getItem('plannerCourse')) {
          this.selectedCourse_navigation = parseInt(localStorage.getItem('plannerCourse'));
        } else {
          this.selectedCourse_navigation = this.courses_navigation[0].courseID
        }
      }
      
      if (sessionStorage.getItem('userSelectedCourse')) {
        index = this.subscribedCourses.findIndex((item: any) => item.courseName == sessionStorage.getItem('userSelectedCourse'))
      }
    }
    if (this.subscribedCourses.length > 1) {
      this.individualCourseData(this.courseId[index]);
    } else {
      this.getNumbers()
    }
    this.innerWidth = window.innerWidth;
    if(this.innerWidth>750){
    document.getElementById('eup-navbar-heading').innerText = 'Dashboard';
  }else{
    document.getElementById('eup-navbar-heading').innerText = '';
  }


    await this.getDataCount();

    // ************** GET CATEGORIES AND QUESTION COUNT
  //   if(localStorage.getItem("getCategories")){
  //     var getCatResult = JSON.parse(localStorage.getItem("getCategories"));
  //     for(let i = 0; i< getCatResult.Categories.length; i++){
  //        if(getCatResult.Categories[i].parentCategory == "q-courses"){
  //           this.courses = getCatResult.Categories[i].subCategories;
  //         }
  //       }

  //       for(let i=0; i<this.courses.length; i++){
  //         this.selectedCourse = this.courses[i];
  //         await this.getQuestionNumbers();
  //       }
  //   }
  //   else{
  //   await this.getAllCategories();
  // }


    monkeyPatchChartJsTooltip();
    monkeyPatchChartJsLegend();

    this.getSaturdayRange()
    // Load study planner stats
   
   

    this.getStudyPlannerStats();


  
    // Initialize current week for week-wise filtering
    // this.initializeCurrentWeek();

    this.globalService.tawkIO(localStorage.getItem('UserName'), localStorage.getItem('email')) ;
    }
  }



  searchCourse(): void{
    console.log(this.searchText.toLowerCase() , this.finalCourseArray)
    // if(this.searchText == ''){
    //   this.finalCourseArray2 = this.finalCourseArray;
    // }
    // else{

      // @ts-ignore
      this.smallfinalarray = this.finalCourseArray.filter(course => {
        return (course.post_title).toLowerCase().includes(this.searchText);
      })
    // }
  }

  getDemoVariables(): any{
    console.log('Getting Demo Variables')
    this.finalCourseArray = this.smallfinalarray;

    this.contentLoader = false;
    localStorage.setItem("coursearray", JSON.stringify(this.smallfinalarray));
    // this.smallfinalarray = demo_variables.smallfinalarray;
  }


  getData(): void{
    this.contentLoader = true;
    // @ts-ignore
    this.subscriptions.push(
      this.courseService.getAllCourses().subscribe((res: any) => {
        this.loader = false;
        if(res.status){
          this.courses = res.courseDetails;
          // res.courseDetails.forEach((course: any) => {
          //   this.courses.push(
          //     {
          //       courseId: course.ID,
          //       courseTitle: course.post_title,
          //       courseIntro: course.post_excerpt,
          //     }
          //   )
          // });
          this.contentLoader = false;
          this.getDataCount();


        }
      },
        error => {
          this.errorHandler.handleError(error);
        })
    );
  }

  subscribedCourses: any = [];
  getNumbers(): void{
    // this.contentLoader = true;
    var quizId = "";
    // @ts-ignore
    this.subscriptions.push(
      this.courseService.getNumbers(quizId, this.courseId).subscribe((res: any) => {
        this.totalQues = res.totalQuestions;
        this.unusedQues = res.totalQuestions - res.totalUsedQuestions;
        this.usedQues = res.totalUsedQuestions;
        this.totalCorrectPercentage = ((res.totalCorrectQuestions / (res.totalCorrectQuestions + res.totalIncorrectQuestions + res.totalOmittedQuestions)) * 100).toFixed(1);
        if(this.totalCorrectPercentage>100){
          this.totalCorrectPercentage = 100;
        }
        this.totalUsedPercentage = ((res.totalUsedQuestions/res.totalQuestions)*100).toFixed(1);
        if(this.totalUsedPercentage>100){
          this.totalUsedPercentage = 100;
        }
        // this.totalUsedPercentage = Math.ceil(this.totalUsedPercentage)
        this.pieChartData1 = []
        this.pieChartData1.push(this.totalQues);
        this.pieChartData1.push(this.usedQues);
        this.pieChartData1.push(this.unusedQues);
        this.cardLabels1[0].value = this.totalQues;
        this.cardLabels1[1].value = this.usedQues;
        this.cardLabels1[2].value = this.unusedQues;

        this.pieChartData = [];
        this.pieChartData.push(res.totalCorrect_Correct);
        this.pieChartData.push(res.totalCorrect_Incorrect);
        this.pieChartData.push(res.totalIncorrect_Correct);
        this.pieChartData.push(res.totalIncorrect_Incorrect);

        this.cardLabels[0].value = res.totalCorrectQuestions;
        this.cardLabels[1].value = res.totalIncorrectQuestions;
        this.cardLabels[2].value = res.totalOmittedQuestions;

      },
        error => {
          this.errorHandler.handleError(error);
        })
    );
  }

  individualCourseData(course_id: any){
    this.courseId = [course_id];
    this.getNumbers();

    this.getStudyPlannerStats()
  }


  getDataCount(): void{
    this.contentLoader = true

     // @ts-ignore
     this.subscriptions.push(
      this.courseService.getCourseDataCount().subscribe((res: any) => {
        if(res.status){

          this.totalcourses = res.data.totalCourses;
          this.completedcouses = res.data.completedCourses;
          this.enrolledcourses = res.data.enrolledCourses;
          this.percentages = res.data.courseCompletionStatus;
          this.smallfinalarray = [];
          for(let j=0; j<res.data.courseCompletionStatus.length; j++){
            this.smallfinalarray.push({ID: res.data.courseCompletionStatus[j].courseId, post_title: res.data.courseCompletionStatus[j].post_title, value: res.data.courseCompletionStatus[j].value, post_name: res.data.courseCompletionStatus[j].post_value, courseImage: res.data.courseCompletionStatus[j].courseImage})
          }
          this.finalCourseArray = this.smallfinalarray;

        //   res.data.courseCompletionStatus.forEach((course: any) => {
        //     this.completionValue.push(
        //       {
        //         // @ts-ignore
        //         value: parseFloat(course.value * this.multiplier).toFixed(2)
        //       }
        //     )
        //   })
        // @ts-ignore
        // this.finalCourseArray = this.courses.map(t1 => ({...t1, ...this.percentages.find(t2 => t2.courseId === t1.ID)}))
        // this.finalCourseArray2 = this.finalCourseArray;

        // @ts-ignore
        // this.smallfinalarray = this.finalCourseArray.map(({ID, post_name, post_title, value}) => ({ID, post_name, post_title, value}))

        localStorage.setItem("coursearray", JSON.stringify(this.smallfinalarray));
        this.contentLoader = false;

        }
      },
        error => {
          this.errorHandler.handleError(error);
        })
    );
  }


  // GETTING RESULTS FOR GENERATE QUIZ SCREEN
  AllCategories: any;
  totalQuestion: any
  subjects: any;
  systems: any;
  topics: any;

  subjectQuestionNumberarray;
  selectedCourse;
  systemQuestionNumberarray;
  topicQuestionNumberarray;
  totalResponseFromGetQuestions = [];
  async getQuestionNumbers(){
    // @ts-ignore
    this.subscriptions.push(
      this.quizgeneratorService.getAllQuestionsNumbers(this.selectedCourse).subscribe((res: any) => {
        this.totalResponseFromGetQuestions.push(res)
        // this.subjectQuestionNumberarray = [];
        // this.systemQuestionNumberarray = [];
        // this.topicQuestionNumberarray = [];
        // this.subjects = [];
        // this.systems = [];
        // this.topics = [];
        // for(let i=0; i<res.subjects.length; i++){
        //   this.subjects.push(res.subjects[i].Title);
        //   this.subjectQuestionNumberarray.push({title: res.subjects[i].Title,questions: res.subjects[i].questions})
        // }
        // for(let i=0; i<res.systems.length; i++){
        //   this.systems.push(res.systems[i].Title);
        //   this.systemQuestionNumberarray.push({title: res.systems[i].Title,questions: res.systems[i].questions})
        // }
        // for(let i=0; i<res.topics.length; i++){
        //   this.topics.push(res.topics[i].Title);
        //   this.topicQuestionNumberarray.push({title: res.topics[i].Title,questions: res.topics[i].questions})
        // }
        // // this.selectedCategories = []
        if(res.status){
        localStorage.setItem("getQuestionNUmbers", JSON.stringify(this.totalResponseFromGetQuestions));
        }

      }))
  }

  // Study Planner Stats Methods
  getStudyPlannerStats(): void {
    if (this.demo) {
      // Demo data for study planner
      this.studyPlannerStats = {
        completedTasks: 5,
        overdueTasks: 3,
        incompleteTasks: 7,
        completionPercentage: 33
      };
      this.upcomingTasks = [
        {
          id: '1',
          description: 'Practice Questions - Cardiology',
          type: 'practiceQuestions',
          durationMinutes: 90
        },
        {
          id: '2', 
          description: 'Watch: Anatomy Video',
          type: 'courseVideos',
          durationMinutes: 45
        }
      ];
      this.overdueTasks = [
        {
          id: '3',
          description: 'Flashcards Review',
          type: 'flashcards',
          durationMinutes: 30
        }
      ];
      this.updateStudyPlannerChart();
      this.hasNoDataForCurrentWeek = false;
      this.showWeekNavigation = true;
      return;
    }

    this.studyPlannerLoader = true;
    const userId = localStorage.getItem('Id');
    const courseId = this.courseId[0] || localStorage.getItem('courseId');

    // Format dates for API call
    const startDate = this.formatDateForAPI(this.currentWeekStart);
    const endDate = this.formatDateForAPI(this.currentWeekEnd);

    this.subscriptions.push(
      this.studyPlanService.getTasksStats(courseId, userId, startDate, endDate).subscribe((res: any) => {
        this.studyPlannerLoader = false;

        console.log(res)
        if (res && res.success) {
          this.studyPlannerData = res.data;
          this.upcomingTasks = res.data.upcomingTasks || [];
          this.overdueTasks = res.data.overdueTasks || [];
          this.studyPlannerStats = res.data.statistics || {
            completedTasks: 0,
            overdueTasks: 0,
            incompleteTasks: 0,
            completionPercentage: 0
          };
          
          // Check if there's any data for current week
          const totalTasks = this.upcomingTasks.length + this.overdueTasks.length + this.studyPlannerStats.completedTasks;
          this.hasNoDataForCurrentWeek = totalTasks === 0;
          this.showWeekNavigation = true;
          
          this.updateStudyPlannerChart();
        } else {
          // Handle no data case
          this.studyPlannerStats = {
            completedTasks: 0,
            overdueTasks: 0,
            incompleteTasks: 0,
            completionPercentage: 0
          };
          this.upcomingTasks = [];
          this.overdueTasks = [];
          this.hasNoDataForCurrentWeek = true;
          this.showWeekNavigation = true;
          this.updateStudyPlannerChart();
        }
      }, error => {
        this.studyPlannerLoader = false;
        console.error('Error fetching study planner stats:', error);
        // Set empty data on error
        this.studyPlannerStats = {
          completedTasks: 0,
          overdueTasks: 0,
          incompleteTasks: 0,
          completionPercentage: 0
        };
        this.upcomingTasks = [];
        this.overdueTasks = [];
        this.hasNoDataForCurrentWeek = true;
        this.showWeekNavigation = true;
        this.updateStudyPlannerChart();
      })
    );
  }

  updateStudyPlannerChart(): void {
    const totalTasks = this.studyPlannerStats.completedTasks + 
                      this.studyPlannerStats.overdueTasks + 
                      this.studyPlannerStats.incompleteTasks;
    
    if (totalTasks === 0) {
      // If no tasks, show 100% grey
      this.studyPlannerChartData = [0, 0, 0, 100];
    } else {
      // Calculate percentages
      const completedPercentage = Math.round((this.studyPlannerStats.completedTasks / totalTasks) * 100);
      const overduePercentage = Math.round((this.studyPlannerStats.overdueTasks / totalTasks) * 100);
      const incompletePercentage = Math.round((this.studyPlannerStats.incompleteTasks / totalTasks) * 100);
      
      // Calculate remaining percentage to make total 100%
      const usedPercentage = completedPercentage + overduePercentage + incompletePercentage;
      const remainingPercentage = Math.max(0, 100 - usedPercentage);
      
      this.studyPlannerChartData = [
        completedPercentage,
        overduePercentage,
        incompletePercentage,
        remainingPercentage
      ];
    }
  }

  switchTab(tab: string): void {
    this.selectedTab = tab;
  }

  formatDuration(decimalHours: number): string {
    // Handle edge case
    if (decimalHours === 0) {
      return '0 mins';
    }
    
    // Split into whole hours and decimal part
    const wholeHours = Math.floor(decimalHours);
    const decimalPart = decimalHours - wholeHours;
    
    // Convert decimal part to minutes (0.2 hour = 0.2 * 60 = 12 minutes)
    const minutes = Math.round(decimalPart * 60);
    
    // Format the result
    if (wholeHours === 0) {
      // Less than 1 hour, show only minutes
      return `${minutes} mins`;
    } else if (minutes === 0) {
      // Exact hours, no minutes
      return wholeHours === 1 ? '1hr' : `${wholeHours}hrs`;
    } else {
      // Hours and minutes
      const hourText = wholeHours === 1 ? '1hr' : `${wholeHours}hrs`;
      return `${hourText}, ${minutes}mins`;
    }
  }

  getTaskTypeColor(type: string): string {
    switch (type) {
      case 'flashcards':
        return 'rgb(255, 169, 64)';
      case 'practiceQuestions':
        return 'rgb(255, 133, 192)';
      case 'courseVideos':
        return 'rgb(105, 192, 255)';
      default:
        // Alternate between two colors for other types
        return 'rgb(149, 222, 100)' ;
    }
  }

  getCurrentDate(): string {
    const today = new Date();
    const options: Intl.DateTimeFormatOptions = { 
      weekday: 'long', 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    };
    return `Today, ${today.toLocaleDateString('en-US', options)}`;
  }

  hasNoTasks(): boolean {
    return this.upcomingTasks.length === 0 && this.overdueTasks.length === 0;
  }

  getCurrentTasks(): any[] {
    return this.selectedTab === 'upcoming' ? this.upcomingTasks : this.overdueTasks;
  }

  /**
   * Get the appropriate placeholder message based on current tab and task availability
   */
  getPlaceholderMessage(): { title: string; description: string } {
    if (this.selectedTab === 'upcoming' && this.upcomingTasks.length === 0 && this.overdueTasks.length > 0) {
      return {
        title: 'You have overdue tasks remaining. Please complete them.',
        description: 'Switch to the overdue tab to view and complete your pending tasks.'
      };
    } else if (this.upcomingTasks.length === 0 && this.overdueTasks.length === 0) {
      return {
        title: 'You\'re all caught up!',
        description: 'Take a break or load next week\'s tasks to continue studying.'
      };
    } else {
      // For overdue tab with no overdue tasks (but has upcoming tasks)
      return {
        title: 'No overdue tasks!',
        description: 'Great job staying on track with your study plan.'
      };
    }
  }

  /**
   * Toggle task completion status
   * @param task The task to toggle
   */
  toggleTaskCompletion(task: any): void {
    // Prevent multiple clicks while loading
    if (this.studyPlannerLoader) {
      return;
    }

    // Call API to update task status
    this.updateTaskStatus(task.planId, task.id, !task.isCompleted);
  }

  /**
   * Update task completion status via API
   * @param planId Plan ID
   * @param taskId Task ID  
   * @param isCompleted New completion status
   */
  updateTaskStatus(planId: string, taskId: string, isCompleted: boolean): void {
    this.studyPlannerLoader = true;
    
    const updateData = { isCompleted: isCompleted };
    
    this.subscriptions.push(
      this.studyPlanService.updateTask(planId, taskId, updateData).subscribe({
        next: (response) => {
          console.log('Task updated successfully:', response);
          // Refresh all stats and tasks data
          this.getStudyPlannerStats();
        },
        error: (error) => {
          console.error('Error updating task:', error);
          this.studyPlannerLoader = false;
          // Could add toast notification here for error feedback
        }
      })
    );
  }

  // Week calculation and navigation methods
  
  /**
   * Calculate Saturday-to-Saturday week dates for a given date
   * @param date The reference date
   * @returns Object with start and end dates of the week
   */
  calculateWeekDates(date: Date): { start: Date, end: Date } {
    const currentDate = new Date(date);
    const dayOfWeek = currentDate.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
    
    // Calculate days to subtract to get to the most recent Saturday
    let daysToSaturday: number;
    if (dayOfWeek === 6) {
      // If today is Saturday, this is the start of the current week
      daysToSaturday = 0;
    } else {
      // Otherwise, go back to the previous Saturday
      daysToSaturday = (dayOfWeek + 1) % 7;
      if (daysToSaturday === 0) daysToSaturday = 7;
    }
    
    const weekStart = new Date(currentDate);
    weekStart.setDate(currentDate.getDate() - daysToSaturday);
    weekStart.setHours(0, 0, 0, 0);
    
    const weekEnd = new Date(weekStart);
    weekEnd.setDate(weekStart.getDate() + 6); // Saturday to Friday (next Friday)
    weekEnd.setHours(23, 59, 59, 999);
    
    return { start: weekStart, end: weekEnd };
  }

  /**
   * Initialize current week dates
   */
  initializeCurrentWeek(): void {
    const today = new Date();
    const weekDates = this.calculateWeekDates(today);
    this.currentWeekStart = weekDates.start;
    this.currentWeekEnd = weekDates.end;
    this.updateWeekLabel();
  }

  /**
   * Update the week label for display
   */
  updateWeekLabel(): void {
    const options: Intl.DateTimeFormatOptions = { 
      month: 'short', 
      day: 'numeric',
      year: this.currentWeekStart.getFullYear() !== this.currentWeekEnd.getFullYear() ? 'numeric' : undefined
    };
    
    const startStr = this.currentWeekStart.toLocaleDateString('en-US', options);
    const endStr = this.currentWeekEnd.toLocaleDateString('en-US', options);
    
    this.currentWeekLabel = `${startStr} - ${endStr}`;
  }

  /**
   * Navigate to next week
   */
  goToNextWeek(): void {
    const nextWeekDate = new Date(this.currentWeekStart);
    nextWeekDate.setDate(this.currentWeekStart.getDate() + 7);
    
    const weekDates = this.calculateWeekDates(nextWeekDate);
    this.currentWeekStart = weekDates.start;
    this.currentWeekEnd = weekDates.end;
    this.updateWeekLabel();
    this.getStudyPlannerStats();
  }

  /**
   * Navigate to previous week
   */
  goToPreviousWeek(): void {
    const prevWeekDate = new Date(this.currentWeekStart);
    prevWeekDate.setDate(this.currentWeekStart.getDate() - 7);
    
    const weekDates = this.calculateWeekDates(prevWeekDate);
    this.currentWeekStart = weekDates.start;
    this.currentWeekEnd = weekDates.end;
    this.updateWeekLabel();
    this.getStudyPlannerStats();
  }

  /**
   * Format date to YYYY-MM-DD string for API calls
   */
  formatDateForAPI(date: Date) {
    return date.toISOString().split('T')[0];
  }

  getSaturdayRange = () => {
    const today = new Date();

    // Clone the date to avoid mutating the original
    const start = new Date(today);
    const end = new Date(today);

    // Get current day (0 = Sunday, 6 = Saturday)
    const dayOfWeek = today.getDay();

    // Calculate current or previous Sunday (start of range)
    const daysSinceSunday = dayOfWeek;
    start.setDate(today.getDate() - daysSinceSunday);

    // Calculate next or current Saturday (end of range)
    const daysUntilSaturday = 6 - dayOfWeek;
    end.setDate(today.getDate() + daysUntilSaturday);

    this.currentWeekStart = start
    this.currentWeekEnd = end
  };

  /**
   * Navigate to appropriate task interface based on task type
   * Replicates the functionality from calendar component
   * @param task The task to navigate to
   */
  navigateToTask(task: any) {
    this.selectedQbanks = task.questionsData || task.details || [];
    
    if (task.type === 'flashcards') {
      this.router.navigateByUrl('/dashboard/ready-flashcards')
    } else if (task.type === 'practiceQuestions') {
      

      this.displayQuiz = true;

      console.log(this.selectedQbanks , this.selectedCourse_navigation , this.displayQuiz)
    } else if (task.type === 'courseVideos') {
      const questionData = task.questionsData || task.details || {};
      
      if (questionData.courseId) {
        this.gotoFocusboard(
          questionData.courseId, 
          questionData.courseTitle, 
          questionData.lessonId, 
          questionData.lessonTitle, 
          questionData.topicId, 
          questionData.topicTitle, 
          0
        );
      } else if (questionData.videoLink) {
        this.getCourseVideoContent(questionData.videoLink);
        this.showVideoModal = true;
      } else {
        this.router.navigateByUrl('/dashboard/courses')
      }
    }
  }

  /**
   * Navigate to focusboard with course details
   * @param courseId Course ID
   * @param courseName Course name
   * @param lessonId Lesson ID
   * @param lessonName Lesson name
   * @param topicId Topic ID
   * @param topicName Topic name
   * @param index Index
   */
  gotoFocusboard(courseId: any, courseName: any, lessonId: any, lessonName: any, topicId: any, topicName: any, index: any): void{
    localStorage.setItem("lessonName", lessonName);
    localStorage.setItem("lessonNumber", index);
    localStorage.setItem("topicID", topicId);
    localStorage.setItem("LessonID", lessonId);
    localStorage.setItem("CourseID", JSON.stringify(courseId));

    courseName = courseName.replace(/\s/g, '-')
    lessonName = lessonName.replace(/\s/g, '-').replace("(", '-').replace(")", '-')
    topicName = topicName.replace(/\s/g, '-').replace("(", '-').replace(")", '-')

    this.router.navigate(['focusboard', courseName, lessonName, topicName ]);
  }

  /**
   * Close video modal
   */
  closeVideoModal(): void {
    this.showVideoModal = false;
    this.currentVideoUrl = null;
  }

  /**
   * Get course video content and setup VdoCipher player
   * @param videoLink Video link
   */
  getCourseVideoContent(videoLink: any) {
    return new Promise((resolve: any) => {
      this.studyPlanService.getCourseVideoContent(videoLink, localStorage.getItem('Id')).subscribe((res: any) => {
        if (res.data) {
          this.currentVideoUrl = this.sanitizer.bypassSecurityTrustResourceUrl("https://player.vdocipher.com/v2/?otp=" + res.data.video.otp + "&playbackInfo=" + res.data.video.playbackInfo + "&primaryColor=#4245ef");
          this.videoCypher()
        }
        resolve(true)
      },
      (err: any) => {
        resolve(false)
      })
    })
  }

  /**
   * Initialize VdoCipher video player with playback speed options
   */
  videoCypher() {
    const iframe = document.querySelector("iframe");
    // Creating player instance
    const player = (window as any).VdoPlayer.getInstance(iframe);

    // All DOM API supports on player.video
    player.video.addEventListener("load", function () {
      player.video.availablePlaybackRates = [0.75, 1.0, 1.25, 1.5, 1.75, 2.0];
    });
  }

}
